import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=82da60ae&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=82da60ae&lang=scss&scoped=true&"
import style1 from "./statistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da60ae",
  null
  
)

export default component.exports